export default {
  ANNOUNCEMENT_BANNER: "announcement banner",
  HERO: "hero",
  SPOTLIGHT: "spotlight",
  SHELF: "shelf",
  HEADER: "header",
  NAV: "nav",
  FOOTER: "footer",
  PROFILE: "profile",
  CREATE_ACCOUNT: "create account",
  LOGIN: "login",
  FAVORITES: "favorites",
  TRANSMOGRIFIER: "transmogrifier",
  CLEVER: "clever",
  GOOGLE: "google",
};
